import React from 'react';
import {IEmptyModel} from '../../src/@interfaces/IEmptyModel';
import {FormFieldsProps} from '../../src/@types/components/Form';
import FormFields from '../../src/components/Form/FormFields';

export default function OrderFormFields<Model extends IEmptyModel>(props: FormFieldsProps<Model>) {
    return <FormFields {...props}/>;
}
